(() => {
  // eslint-disable-next-line
  var listLogo = new Swiper(".js-list-logo-slider-init", {
    slidesPerView: "auto",
    spaceBetween: 40,
    centeredSlides: false,
    breakpoints: {
      575: {
        slidesPerView: "auto",
        spaceBetween: 40,
        centeredSlides: false,
      },
      767: {
        slidesPerView: "auto",
        spaceBetween: 40,
        centeredSlides: false,
      },
      991: {
        slidesPerView: 7,
        spaceBetween: 28,
        centeredSlides: false,
      },
    },
  });

  // eslint-disable-next-line
  var homeHeroSlider = new Swiper(".js-home-hero-slider-init", {
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
  });

  // //Text and Img padding calculate

  // function checkMediaQuery() {
  //   console.log(window.innerWidth);
  //   if (window.innerWidth > 1499) {
  //     const textImgWrapper = document.querySelectorAll('.text-and-img__wrapper');
  //     textImgWrapper.forEach((item) => {
  //       let itemHeight = item.offsetHeight,
  //         itemMediaHeight = item.firstElementChild.firstElementChild.offsetHeight;
  //       let itemMediaPaddingBottom = itemHeight - itemMediaHeight;
  //       console.log(itemHeight);
  //       console.log(itemMediaHeight);
  //       console.log(itemMediaPaddingBottom);
  //       if (itemMediaPaddingBottom > 0) {
  //         item.firstElementChild.style.paddingBottom = `${itemMediaPaddingBottom + 5}px`;
  //       }
  //     });
  //   }
  // }
  // window.addEventListener('resize', checkMediaQuery);
  // checkMediaQuery();

  //Contact form
  const validRegex =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*$/;

  if (
    document.querySelectorAll(".js-main-contact").length ||
    document.querySelectorAll(".js-ask-dentist").length
  ) {
    const checkbox = document.querySelector("#ContactForm-checkbox"),
      checkboxRegister = document.querySelector("#RegisterForm-checkbox"),
      btnForm = document.querySelector("#ContactForm-submit-btn"),
      requiredInputsName = document.querySelectorAll(".js-field__input--name"),
      requiredInputPhone = document.querySelector(".js-field__input--phone"),
      requiredInputEmail = document.querySelector(".js-field__input--email"),
      requiredInputMessage = document.querySelector(
        ".js-field__input--message"
      ),
      requiredInputPassword = document.querySelector(
        ".js-field__input--password"
      ),
      requiredInputBirthDate = document.querySelector(
        ".js-field__input--birth-date"
      );

    let maxLengthText = Number(requiredInputMessage.getAttribute("minlength"));

    //email validation

    //disable/enable submit button
    btnForm.disabled = true;
    // checkbox.addEventListener('change', function () {
    //   if (this.checked) {
    //     btnForm.disabled = false;
    //   } else {
    //     btnForm.disabled = true;
    //   }
    // });
    function checkCheckboxes() {
      if (
        (checkbox.checked && checkboxRegister == undefined) ||
        (checkbox.checked && checkboxRegister && checkboxRegister.checked)
      ) {
        btnForm.disabled = false;
      } else {
        btnForm.disabled = true;
      }
    }
    checkbox.addEventListener("change", function () {
      checkCheckboxes();
    });
    checkboxRegister &&
      checkboxRegister.addEventListener("change", function () {
        checkCheckboxes();
      });

    //inputs validation
    btnForm.addEventListener("click", function () {
      requiredInputsName.forEach(input => {
        isEmptyInput(input);
      });

      function isEmptyInput(input) {
        if (input.hasAttribute("required") && input.value.length < 1) {
          input.nextElementSibling.style.display = "block";
        } else {
          input.nextElementSibling.style.display = "none";
        }
      }
      requiredInputPassword && isEmptyInput(requiredInputPassword);
      requiredInputBirthDate && isEmptyInput(requiredInputBirthDate);

      if (
        requiredInputPhone.hasAttribute("required") &&
        !/^[0-9+]+$/.test(requiredInputPhone.value)
      ) {
        requiredInputPhone.nextElementSibling.style.display = "block";
      } else {
        requiredInputPhone.nextElementSibling.style.display = "none";
      }
      if (
        requiredInputEmail.hasAttribute("required") &&
        !requiredInputEmail.value.match(validRegex)
      ) {
        requiredInputEmail.nextElementSibling.style.display = "block";
      } else {
        requiredInputEmail.nextElementSibling.style.display = "none";
      }
      if (requiredInputMessage) {
        if (
          requiredInputMessage.hasAttribute("required") &&
          requiredInputMessage.value.length < maxLengthText
        ) {
          requiredInputMessage.nextElementSibling.style.display = "block";
        } else {
          requiredInputMessage.nextElementSibling.style.display = "none";
        }
      }
    });
  }

  //question form validator
  if (document.querySelectorAll(".question-form").length) {
    const btnForm = document.querySelector("#ContactForm-submit-btn"),
      requiredInputsName = document.querySelectorAll(".js-field__input--name"),
      requiredInputEmail = document.querySelector(".js-field__input--email"),
      requiredInputMessage = document.querySelector(
        ".js-field__input--message"
      ),
      requiredInputPassword = document.querySelector(
        ".js-field__input--password"
      );

    let maxLengthText = Number(requiredInputMessage.getAttribute("minlength"));

    //inputs validation
    btnForm.addEventListener("click", function () {
      requiredInputsName.forEach(input => {
        isEmptyInput(input);
      });

      function isEmptyInput(input) {
        if (input.hasAttribute("required") && input.value.length < 1) {
          input.nextElementSibling.style.display = "block";
        } else {
          input.nextElementSibling.style.display = "none";
        }
      }
      requiredInputPassword && isEmptyInput(requiredInputPassword);

      if (document.querySelectorAll(".field__radio-box").length) {
        const radioGroups = document.querySelectorAll(".field__radio-box");

        radioGroups.forEach(group => {
          const radios = group.querySelectorAll('input[type="radio"]');
          const invalidMessage = group.querySelector(".field__invalid");

          function checkAndDisplayError() {
            const isAnyChecked = Array.from(radios).some(
              radio => radio.checked
            );
            invalidMessage.style.display = isAnyChecked ? "none" : "block";
          }

          checkAndDisplayError();
        });
      }

      if (
        requiredInputEmail.hasAttribute("required") &&
        !requiredInputEmail.value.match(validRegex)
      ) {
        requiredInputEmail.nextElementSibling.style.display = "block";
      } else {
        requiredInputEmail.nextElementSibling.style.display = "none";
      }
      if (requiredInputMessage) {
        if (
          requiredInputMessage.hasAttribute("required") &&
          requiredInputMessage.value.length < maxLengthText
        ) {
          requiredInputMessage.nextElementSibling.style.display = "block";
        } else {
          requiredInputMessage.nextElementSibling.style.display = "none";
        }
      }
    });
  }

  //Account pages form validate
  const accountBtnForm = document.querySelectorAll(".js-form-submit-btn"),
    accountRequiredInputsPassword = document.querySelectorAll(
      ".js-field__input--password"
    ),
    accountRequiredInputEmail = document.querySelectorAll(
      ".js-field__input--email"
    ),
    resetErrors = document.querySelectorAll(".js-reset-errors");

  accountBtnForm.forEach(submitBtn => {
    submitBtn.addEventListener("click", function () {
      accountRequiredInputsPassword.forEach(input => {
        if (input.hasAttribute("required") && input.value.length < 1) {
          input.nextElementSibling.style.display = "block";
        } else {
          input.nextElementSibling.style.display = "none";
        }
      });
      accountRequiredInputEmail.forEach(emailInput => {
        if (
          emailInput.hasAttribute("required") &&
          !emailInput.value.match(validRegex)
        ) {
          emailInput.nextElementSibling.style.display = "block";
        } else {
          emailInput.nextElementSibling.style.display = "none";
        }
      });
    });
  });

  resetErrors.forEach(resetBtn => {
    resetBtn.addEventListener("click", function () {
      document.querySelectorAll(".field__invalid").forEach(errorItem => {
        errorItem.style.display = "none";
      });
    });
  });

  /* Blogs slider */

  const blogsSlider = new Swiper(".js-blogs-slider__swiper", {
    slidesPerView: 1.2,
    spaceBetween: 15,
    arrows: false,
    navigation: {
      nextEl: ".js-blogs-slider-button-next",
      prevEl: ".js-blogs-slider-button-prev",
    },
    breakpoints: {
      320: {
        slidesPerView: 1.15,
      },
      450: {
        slidesPerView: 1.4,
      },
      550: {
        slidesPerView: 1.8,
      },
      650: {
        slidesPerView: 2.1,
      },
      767: {
        slidesPerView: 2.2,
      },
      820: {
        slidesPerView: 2.4,
      },
      920: {
        slidesPerView: 2.8,
      },
      989: {
        slidesPerView: 2.8,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  });

  /* Article like products slider */

  const likeProductsSlider = new Swiper(".js-like-products__swiper", {
    slidesPerView: 2.3,
    spaceBetween: 15,
    watchOverflow: true,
    navigation: {
      nextEl: ".js-like-products-button-next",
      prevEl: ".js-like-products-button-prev",
    },
    breakpoints: {
      1200: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      990: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      620: {
        slidesPerView: 2.3,
        spaceBetween: 20,
      },
      480: {
        slidesPerView: 2.3,
        spaceBetween: 20,
      },
    },
  });

  /* Article like sidebar slider */
  if (document.querySelectorAll(".js-like-side__swiper").length) {
    if (window.matchMedia("(max-width: 991px)").matches) {
      const likeProductsSidebar = new Swiper(".js-like-side__swiper", {
        slidesPerView: 2.3,
        spaceBetween: 15,
        watchOverflow: true,
        breakpoints: {
          1200: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          990: {
            slidesPerView: 1.5,
            spaceBetween: 20,
          },
          620: {
            slidesPerView: 2.3,
            spaceBetween: 20,
          },
          480: {
            slidesPerView: 2.3,
            spaceBetween: 20,
          },
        },
      });
    }
  }

  //megamenu
  const menuLinkHasMega = document.querySelectorAll(".js-mega-menu"),
    menuMega = document.querySelectorAll(".header__mega-menu-wrapper");

  menuLinkHasMega.forEach((link, index) => {
    link.addEventListener("mouseover", () => {
      menuMega[index].classList.add("open");
      menuLinkHasMega[index].classList.add("open");
    });
    link.addEventListener("mouseout", () => {
      menuMega[index].classList.remove("open");
      menuLinkHasMega[index].classList.remove("open");
    });
  });

  menuMega.forEach((menu, index) => {
    menu.addEventListener("mouseover", () => {
      menuLinkHasMega[index].classList.add("open");
    });
    menu.addEventListener("mouseout", () => {
      menuLinkHasMega[index].classList.remove("open");
    });
  });

  if (document.querySelectorAll(".blog-post").length) {
    window.addEventListener("resize", likeProductArrows);
    function likeProductArrows() {
      if (likeProductsSlider.slides.length < 3 && window.innerWidth > 989) {
        document
          .querySelector(".blog-post__like-products")
          .classList.add("blog-post__like-products--disable");
      }
    }
  }

  // if (document.querySelectorAll('.js-like-products__swiper').length) {
  //   const likeProductsSlider = new Swiper('.js-like-products__swiper', {
  //     slidesPerView: 1,
  //     spaceBetween: 15,
  //     watchOverflow: true,
  //     navigation: {
  //       nextEl: '.js-like-products-button-next',
  //       prevEl: '.js-like-products-button-prev',
  //     },
  //     breakpoints: {
  //       990: {
  //         slidesPerView: 2,
  //         spaceBetween: 20,
  //       },
  //     },
  //   });

  //   if (likeProductsSlider.slides.length < 3 && window.innerWidth > 989) {
  //     document.querySelector(".blog-post__like-products-swiper").classList.add("blog-post__like-products-swiper--disable");
  //     likeProductsSlider.disable();
  //   }
  // }

  //mobile accordion
  const menuLink = document.querySelectorAll(".js-mobile-mega-menu-li");

  menuLink.forEach(link => {
    link.addEventListener("click", function () {
      let container = link.lastElementChild;
      if (!container.classList.contains("active")) {
        container.classList.add("active");
        container.style.height = "auto";
        link.classList.add("open");

        var height = container.clientHeight + "px";

        container.style.height = "0px";

        setTimeout(function () {
          container.style.height = height;
        }, 0);
      } else {
        container.style.height = "0px";
        link.classList.remove("open");
        container.addEventListener(
          "transitionend",
          function () {
            container.classList.remove("active");
          },
          {
            once: true,
          }
        );
      }
    });
  });

  //Show search
  const menuSearch = document.querySelectorAll(
    ".modal__toggle.header__icon--search"
  );

  function showSearch() {
    if (window.innerWidth > 1100) {
      document
        .querySelector(".js-header__search-form-desktop")
        .classList.toggle("open");
      setTimeout(function () {
        document.querySelector("body").classList.remove("overflow-hidden");
      }, 100);
    }
  }

  menuSearch.forEach(btn => {
    btn.addEventListener("click", function () {
      showSearch();
    });
  });

  //window.addEventListener("resize", showSearch);
})();
